"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    n = require("@react-pdf-viewer/core");

function t(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  return e && Object.keys(e).forEach(function (t) {
    if ("default" !== t) {
      var r = Object.getOwnPropertyDescriptor(e, t);
      Object.defineProperty(n, t, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[t];
        }
      });
    }
  }), n.default = e, Object.freeze(n);
}

var r,
    l = t(e),
    _u = function u() {
  return (_u = Object.assign || function (e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      for (var l in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    c = function c() {
  return l.createElement(n.Icon, {
    size: 16
  }, l.createElement("path", {
    d: "M0.5 12L23.5 12"
  }), l.createElement("path", {
    d: "M11.5 1L11.5 23"
  }), l.createElement("path", {
    d: "M8.5 4L11.5 1 14.5 4"
  }), l.createElement("path", {
    d: "M20.5 9L23.5 12 20.5 15"
  }), l.createElement("path", {
    d: "M3.5 15L0.5 12 3.5 9"
  }), l.createElement("path", {
    d: "M14.5 20L11.5 23 8.5 20"
  }));
},
    o = {
  left: 0,
  top: 8
},
    a = function a(e) {
  var t = e.onClick,
      r = l.useContext(n.LocalizationContext),
      u = r && r.fullScreen ? r.fullScreen.enterFullScreen : "Full screen";
  return l.createElement(n.Tooltip, {
    ariaControlsSuffix: "full-screen-enter",
    position: n.Position.BottomCenter,
    target: l.createElement(n.MinimalButton, {
      ariaLabel: u,
      onClick: t
    }, l.createElement(c, null)),
    content: function content() {
      return u;
    },
    offset: o
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


!function (e) {
  e[e.ExitFullScreen = 0] = "ExitFullScreen", e[e.FullScreenChange = 1] = "FullScreenChange", e[e.FullScreenElement = 2] = "FullScreenElement", e[e.FullScreenEnabled = 3] = "FullScreenEnabled", e[e.RequestFullScreen = 4] = "RequestFullScreen";
}(r || (r = {}));

var i = {
  ExitFullScreen: "exitFullscreen",
  FullScreenChange: "fullscreenchange",
  FullScreenElement: "fullscreenElement",
  FullScreenEnabled: "fullscreenEnabled",
  RequestFullScreen: "requestFullscreen"
},
    s = {
  ExitFullScreen: "webkitExitFullscreen",
  FullScreenChange: "webkitfullscreenchange",
  FullScreenElement: "webkitFullscreenElement",
  FullScreenEnabled: "webkitFullscreenEnabled",
  RequestFullScreen: "webkitRequestFullscreen"
},
    f = {
  ExitFullScreen: "msExitFullscreen",
  FullScreenChange: "MSFullscreenChange",
  FullScreenElement: "msFullscreenElement",
  FullScreenEnabled: "msFullscreenEnabled",
  RequestFullScreen: "msRequestFullscreen"
},
    E = "undefined" != typeof window,
    m = E && (r.FullScreenEnabled in document && i || s.FullScreenEnabled in document && s || f.FullScreenEnabled in document && f) || i,
    F = function F(e) {
  return E ? e[m.ExitFullScreen]() : Promise.resolve({});
},
    S = function S() {
  return E ? document[m.FullScreenElement] : null;
},
    d = function d(e) {
  var n = e.children,
      t = e.store,
      r = e.onEnterFullScreen,
      u = e.onExitFullScreen,
      c = l.useRef(t.get("getPagesContainer") ? t.get("getPagesContainer")() : null),
      o = function o() {
    var e = S() === c.current;
    t.update("isFullScreen", e);
    var n = t.get("zoom");
    n && (e ? r(n) : u(n));
  },
      i = function i(e) {
    var n;
    c.current = e(), n = o, E && document.addEventListener(m.FullScreenChange, n);
  };

  l.useEffect(function () {
    return t.subscribe("getPagesContainer", i), function () {
      t.unsubscribe("getPagesContainer", i);
    };
  }, []);
  return (n || function (e) {
    return l.createElement(a, {
      onClick: e.onClick
    });
  })({
    onClick: function onClick() {
      var e = c.current;
      e && function () {
        var e = c.current;
        if (!e) return Promise.resolve();
        var n = S();
        return n && n !== e ? F(n) : Promise.resolve();
      }().then(function () {
        var n;
        n = e, E && n[m.RequestFullScreen]();
      });
    }
  });
},
    b = function b(e) {
  var t = e.onClick,
      r = l.useContext(n.LocalizationContext),
      u = r && r.fullScreen ? r.fullScreen.enterFullScreen : "Full screen";
  return l.createElement(n.MenuItem, {
    icon: l.createElement(c, null),
    onClick: t
  }, u);
},
    g = function g() {
  return l.createElement(n.Icon, {
    size: 16
  }, l.createElement("path", {
    d: "M11.5 23.499L11.5 14.499"
  }), l.createElement("path", {
    d: "M7.5 18.499L11.5 14.499 15.5 18.499"
  }), l.createElement("path", {
    d: "M11.5 1.499L11.5 10.499"
  }), l.createElement("path", {
    d: "M7.5 6.499L11.5 10.499 15.5 6.499"
  }), l.createElement("path", {
    d: "M20.5 12.499L1.5 12.499"
  }));
},
    p = function p(e) {
  var t = e.store,
      r = l.useState(!1),
      u = r[0],
      c = r[1],
      o = l.useContext(n.LocalizationContext),
      a = o && o.fullScreen ? o.fullScreen.exitFullScreen : "Exit full screen",
      i = function i(e) {
    c(e);
  };

  return l.useEffect(function () {
    return t.subscribe("isFullScreen", i), function () {
      t.unsubscribe("isFullScreen", i);
    };
  }, []), l.createElement(l.Fragment, null, u && l.createElement("div", {
    className: "rpv-full-screen__exit-button"
  }, l.createElement("div", {
    className: "rpv-full-screen__exit-button-content"
  }, l.createElement(n.MinimalButton, {
    ariaLabel: a,
    onClick: function onClick() {
      c(!1);
      var e = t.get("getPagesContainer");

      if (e) {
        var n = e();

        if (n) {
          var r = S();
          r && r === n && F(document);
        }
      }
    }
  }, l.createElement(g, null)))));
};

exports.ExitFullScreenIcon = g, exports.FullScreenIcon = c, exports.fullScreenPlugin = function (e) {
  var t = l.useMemo(function () {
    return n.createStore({});
  }, []),
      r = e && e.onEnterFullScreen ? e.onEnterFullScreen : function () {},
      c = e && e.onExitFullScreen ? e.onExitFullScreen : function () {},
      o = function o(e) {
    return l.createElement(d, _u({}, e, {
      store: t,
      onEnterFullScreen: r,
      onExitFullScreen: c
    }));
  },
      i = function i() {
    return l.createElement(p, {
      store: t
    });
  };

  return {
    install: function install(e) {
      t.update("getPagesContainer", e.getPagesContainer), t.update("zoom", e.zoom);
    },
    renderViewer: function renderViewer(e) {
      var n = e.slot;
      return n.subSlot && (n.subSlot.children = l.createElement(l.Fragment, null, l.createElement(i, null), n.subSlot.children)), n;
    },
    EnterFullScreen: o,
    EnterFullScreenButton: function EnterFullScreenButton() {
      return l.createElement(o, null, function (e) {
        return l.createElement(a, _u({}, e));
      });
    },
    EnterFullScreenMenuItem: function EnterFullScreenMenuItem(e) {
      return l.createElement(o, null, function (n) {
        return l.createElement(b, {
          onClick: function onClick() {
            n.onClick(), e.onClick();
          }
        });
      });
    }
  };
};